<div class="car-box" (click)="goToCarDetailsPage(carBrief.carId, carBrief.offerId)">
  <div class="car-image">

    <!-- <p class="spinner" *ngIf="carImage == undefined && carBrief.imageFilename !==''">
    <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
  </p>
  -->
  <img [src]="(carImage != undefined) ? getCarImage() : 'assets/images/car_image_holder.webp'" alt="Car Image">

</div>

<div class="car-data">

  <div class="make-model">
    <h5>{{carBrief.make}} {{carBrief.model}} </h5>
    @if (!isSeller) {
      <div class="car-actions" >
        <button mat-button class="simple-button-{{businessLine?.toLowerCase()}}" matTooltipPosition="above" matTooltip="Favorite"
          (click)="toggleFavorite(carBrief.carId, carBrief.offerId);$event.stopPropagation()">
          <mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">{{carBrief.favorite? "favorite": "favorite_outline"}} </mat-icon>
        </button>
      </div>
    }

    @if (isSeller) {
      <div class="car-actions" >
        <button mat-button matTooltipPosition="above" matTooltip="Favorite"
          (click)="shareCar(carBrief.offerId);$event.stopPropagation()">
          <mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">share</mat-icon>
        </button>
      </div>
    }
  </div>

  <h6>{{carBrief.year }}  </h6>

  @if (carBrief != undefined) {
    <h3>
      {{ moneyFormat(""+$safeNavigationMigration(carBrief!.getCarPrice(businessLine!)?.amount)) }}
      &nbsp;
      <span class="price-currency">
        {{ carBrief!.getCarPrice(businessLine!)?.currency }}
        @if (businessLine==CarBusinessLine.RENT) {
          <span>/J</span>
        }
      </span>
    </h3>
  }

  <h6 class="key-details">
    <!-- <div>{{carBrief.year}}</div> -->
    <div>{{carBrief.mileage}} km</div>
    <div>{{carBrief.gearBox }}</div>
    <div>{{carBrief.fuel}}</div>
    <div class="car-location">
      {{ carBrief.city.substring(0,3) }}...&nbsp;
      <img class="mini-flag" src="assets/images/country-flags/{{carBrief.country}}.png" alt="{{carBrief.country}}">
    </div>
  </h6>
</div>
</div>
